import AppModal from '@components/AppModal';
import Text from '@components/Text';
import { ActivityComponentType, useFlow } from '@stackflow/react';

interface Params {
    message: string;
}

declare module '@stackflow/config' {
    interface Register {
        AlertActivity: Params;
    }
}

const AlertActivity: ActivityComponentType<'AlertActivity'> = ({ params }) => {
    const { message } = params;
    const { pop } = useFlow();
    return (
        <AppModal confirm='닫기' onConfirm={pop}>
            <Text>{message}</Text>
        </AppModal>
    );
};

export default AlertActivity;
